import { Input, Textarea } from "@heroui/react";

const GeneralInfoStep = ({ register, errors }) => {
    return (
        <div className="flex flex-col gap-4">
            <Input
                {...register("name", {
                    required: "Nama supplier wajib diisi",
                })}
                label="Nama Supplier"
                placeholder="Contoh: PT Supplier Utama"
                variant="bordered"
                isInvalid={!!errors.name}
                errorMessage={errors.name?.message}
                isRequired
            />

            <Textarea
                {...register("products_summary")}
                label="Produk yang Dijual"
                placeholder="Contoh: Jagung, Konsentrat, Bekatul"
                variant="bordered"
                minRows={2}
            />

            <Textarea
                {...register("description")}
                label="Deskripsi"
                placeholder="Deskripsi singkat tentang supplier (opsional)"
                variant="bordered"
                minRows={3}
            />
        </div>
    );
};

export default GeneralInfoStep;
